<template>
  <div>
    <div class="grid cross-center ver-padding-40">
      <h1 class="r-margin-30">Процессинги ({{ totalProcessings }})</h1>
      <div class="u-16 u-ls grid cross-center between">
        <div class="u-16 u-5-ss u-6-ms ver-padding-10 ver-padding-0-ls">
          <AppInput
            v-model="search"
            size="small"
            placeholder="Найти по названию"
          ></AppInput>
        </div>
        <div>
          <AppButton type="white" size="mini" @click="loadProcessings"
            >Обновить</AppButton
          >
          <AppButton size="mini" @click="addProcessing"
            >Добавить процессинг</AppButton
          >
        </div>
      </div>
    </div>

    <div class="page-block ver-margin-15 grid table-settings">
      <AppCheckbox
        class="u-16 u-8-ss u-4-ms u-0-ls r-margin-30-ls r-margin-0-ss"
        v-for="(item, index) in columns"
        :key="index"
        v-model="item.value"
        :id="'options-' + item.name"
        >{{ item.label }}</AppCheckbox
      >
    </div>

    <div v-loading="loading">
      <VuePerfectScrollbar class="scroll-area" :settings="scrollsettings">
        <div
          v-infinite-scroll="loadNext"
          infinite-scroll-disabled="loading"
          infinite-scroll-distance="10"
        >
          <el-table
            :data="processingsList"
            :default-sort="{ prop: 'human_name', order: 'ascending' }"
            style="width:100%; position: inherit !important"
            class="settings-table"
            size="medium"
            @row-click="rowClick"
            ref="processingstable"
          >
            <el-table-column type="expand">
              <template slot-scope="props">
                <div class="grid" v-if="showDetails(props.row.id)">
                  <div class="togglerow" @click="rowClick(props.row)"></div>
                  <div class="u grid padding-30">
                    <div class="u-16 grid">
                      <el-tabs v-model="configTabs[props.row.id]" class="u-16">
                        <el-tab-pane
                          v-for="(item, key) in filterTabs(
                            props.row.configuration
                          )"
                          :key="key"
                          :label="key"
                          :name="key"
                        >
                          <div class="u-16 grid">
                            <div class="u-16 ver-margin-5"></div>
                            <div
                              v-for="(obj, index) in filterItems(item)"
                              :key="index"
                              class="u-16 ver-margin-5 grid cross-center"
                            >
                              <div class="access-name">{{ index }}</div>
                              <div>{{ obj.toString() || "—" }}</div>
                            </div>
                          </div>
                        </el-tab-pane>
                      </el-tabs>
                      <hr class="u-16 ver-margin-10" />
                    </div>
                    <div class="u-16 ver-margin-5 grid">
                      <div>
                        <AppButton
                          class="r-margin-20"
                          size="small"
                          @click="handleEdit(props.$index, props.row)"
                          >Изменить</AppButton
                        >
                      </div>
                      <AppButton
                        size="small"
                        :type="props.row.active ? 'red' : 'green'"
                        @click="
                          handleSwitch(
                            props.$index,
                            props.row,
                            !props.row.active
                          )
                        "
                        >{{ textActivateButton(props.row.active) }}</AppButton
                      >
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="data_create" sortable label="Создан">
              <template slot-scope="scope">{{
                scope.row.date_created | momentFormat()
              }}</template>
            </el-table-column>
            <el-table-column
              v-for="(column, index) in columnsList"
              :key="index"
              :prop="column.name"
              :label="column.label"
              :align="column.align"
              :sortable="column.sortable"
            >
              <template slot-scope="scope">
                <div
                  v-if="column.name == 'name' || column.name == 'human_name'"
                >
                  <img
                    class="processing-icon"
                    v-if="column.name == 'human_name'"
                    :src="processingIcon(scope.row.id)"
                    alt
                  />
                  <span>{{ scope.row[column.name] }}</span>
                </div>
                <div v-if="column.name == 'active' || column.name == 'is_test'">
                  <i v-if="scope.row[column.name]" class="el-icon-check"></i>
                  <i v-else class="el-icon-minus"></i>
                </div>
                <div v-if="column.name == 'currency_code'">
                  {{ currencyCharacter(scope.row[column.name]) }}
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </VuePerfectScrollbar>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Vuex from "vuex";
import { apiUrl } from "@/api/apiUrl";
import { mapGetters } from "vuex";
import axios from "axios";
import VueAxios from "vue-axios";
import { _ } from "vue-underscore";
Vue.use(VueAxios, axios);

import VuePerfectScrollbar from "vue-perfect-scrollbar";
import infiniteScroll from "vue-infinite-scroll";

export default {
  name: "Processings",
  data() {
    return {
      loading: true,
      search: "",
      totalProcessings: 0,
      processings: [],
      errorMessage: "Нет данных",
      columns: [
        {
          name: "active",
          value: true,
          label: "Активен",
          align: "center",
          sortable: false,
          order: 2
        },
        {
          name: "is_test",
          value: true,
          label: "Тестовый",
          align: "center",
          sortable: false,
          order: 3
        },
        {
          name: "name",
          value: false,
          label: "Name",
          align: "left",
          sortable: true,
          order: 0
        },
        {
          name: "human_name",
          value: true,
          label: "Human name",
          align: "left",
          sortable: true,
          order: 1
        },
        {
          name: "currency_code",
          value: true,
          label: "Валюта",
          align: "center",
          sortable: false,
          order: 4
        }
      ],
      scrollsettings: {
        suppressScrollY: true,
        swipeEasing: true
      },
      expandedRows: [],
      configTabs: {},
      busy: false,
      bottom: false,
      page: {
        current: 1,
        length: 15
      }
    };
  },
  methods: {
    loadProcessings() {
      this.errorMessage = "Загрузка...";
      this.loading = true;
      this.processings = [];
      this.expandedRows = [];
      this.page.current = 1;
      const config = {
        headers: {
          "Authorization-Token": localStorage.getItem("Authorization-Token")
        }
      };
      axios
        .get(apiUrl + "processing/list", config)
        .then(({ data }) => {
          if (data.state_id == 0) {
            this.processings = [...data.list].sort((a, b) => {
              if (a.human_name > b.human_name) return 1;
              if (a.human_name < b.human_name) return -1;
              return 0;
            });
            this.totalProcessings = data.total || this.processings.length;
            this.errorMessage =
              this.processings.length == 0 ? "Нет данных" : "";
            this.loading = false;
          }
        })
        .then(() => {
          this.search = this.$route.params.filter || "";
          if (this.processings.length > 0) {
            this.$refs.processingstable.toggleRowExpansion(
              this.processings.find(el => el.id == this.$route.params.id),
              true
            );
          }
        });
    },
    loadProcessing(id) {
      let processing = {};
      const config = {
        headers: {
          "Authorization-Token": localStorage.getItem("Authorization-Token")
        }
      };
      axios
        .get(apiUrl + "processing/list/" + id, config)
        .then(({ data }) => {
          if (data.state_id == 0) {
            processing = { ...data.list[0] };
            this.updateProcessing(id, processing);
          }
        })
        .catch(err => {
          console.log(err);
          false;
        });
    },
    updateProcessing(id, processing) {
      let foundIndex = this.processings.findIndex(el => el.id === id);
      let oldProcessing = this.processings.find(el => el.id === id);
      this.$set(oldProcessing, "active", processing.active);
    },
    addProcessing() {
      this.$router.push("create_processing");
    },
    rowClick(row) {
      this.$refs.processingstable.toggleRowExpansion(row);
      let index = this.expandedRows.indexOf(row.id);
      if (index == -1) this.expandedRows.push(row.id);
      else this.expandedRows.splice(index, 1);
      this.$set(this.configTabs, row.id, "general");
    },
    handleEdit(index, row) {
      this.$router.push({
        name: "s_EditProcessing",
        params: { id: row.id, processing: row, filter: this.search }
      });
    },
    handleSwitch(index, row, action) {
      this.hideScroll();
      const text = action ? "Включить" : "Отключить";
      this.$confirm(text + " процессинг <b>" + row.human_name + "</b>?", "", {
        confirmButtonText: "OK",
        cancelButtonText: "Отмена",
        type: "warning",
        dangerouslyUseHTMLString: true
      })
        .then(() => {
          this.showScroll();
          this.switchProcessing(row.id, action, row.human_name);
        })
        .catch(() => {
          this.showScroll();
        });
    },
    switchProcessing(id, active, name) {
      const config = {
        headers: {
          "Authorization-Token": localStorage.getItem("Authorization-Token")
        }
      };
      const text = active ? "подключен" : "отключен";
      axios
        .post(apiUrl + "processing/switch/" + id, { active }, config)
        .then(response => {
          this.$message({
            type: "success",
            message: "Процессинг " + name + " успешно " + text
          });
        })
        .then(response => {
          this.loadProcessing(id);
        })
        .catch(err => {
          console.log(err);
        });
    },
    hideScroll() {
      document.documentElement.style.overflow = "hidden";
    },
    showScroll() {
      document.documentElement.style.overflow = "auto";
    },
    textActivateButton(prop) {
      return prop ? "Отключить" : "Включить";
    },
    showDetails(id) {
      return this.expandedRows.indexOf(id) != -1;
    },
    loadPrev() {
      if (this.page.current > 1) this.page.current -= 1;
    },
    loadNext() {
      if (this.page.current * this.page.length < this.processings.length) {
        this.loading = true;
        setTimeout(() => {
          this.page.current += 1;
          this.loading = false;
        }, 300);
        this.expandedRows = [];
      }
    },
    filterItems(item) {
      if (item.hasOwnProperty("username")) delete item["username"];
      if (item.hasOwnProperty("password")) delete item["password"];
      if (item.hasOwnProperty("token")) delete item["token"];
      if (item.hasOwnProperty("private_key")) delete item["private_key"];

      return item;
    },
    filterTabs(tabs) {
      let arr = tabs;
      return arr;
    }
  },
  computed: {
    ...mapGetters([
      "terminalName",
      "terminalList",
      "processingName",
      "processingIcon",
      "currencyCharacter"
    ]),
    processingsList() {
      return this.processings
        .filter(
          data =>
            !this.search ||
            data.name.toLowerCase().includes(this.search.toLowerCase()) ||
            data.human_name.toLowerCase().includes(this.search.toLowerCase())
        )
        .filter((row, index) => {
          // let start = (this.page.current - 1) * this.page.length;
          let start = 0;
          let end = this.page.current * this.page.length;
          if (index >= start && index < end) return true;
        });
    },
    columnsList() {
      return this.columns
        .filter(el => el.value)
        .sort((a, b) => {
          return a.order - b.order;
        });
    }
  },
  created() {
    this.loadProcessings();
  },
  components: {
    VuePerfectScrollbar
  },
  directives: {
    infiniteScroll
  }
};
</script>
